exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-addon[data-v-a5fd46b8] {\n  line-height: unset;\n}", ""]);

// exports
